// Converts react-google-maps (out dated library!!!) use of legacy context into modern code usable with hooks.

import React from 'react';
import PropTypes from 'prop-types';

import { MAP } from 'react-google-maps/lib/constants';

export const MapContext = React.createContext();

class MapContextShim extends React.PureComponent {

  render() {
    return (
      <MapContext.Provider value={this.context[MAP]}>
        {this.props.children}
      </MapContext.Provider>
    );
  }
}

MapContextShim.contextTypes = {
  [MAP]: PropTypes.object
};

MapContextShim.propTypes = {
  children: PropTypes.node
};

export default MapContextShim;
